import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchBar from "./SearchBar";
import Catagories from "./Catagories";
import SideBarTitle from "./SideBarTitle";
import BlogNewsletter from "./BlogNewsletter";
import imageUrlBuilder from "@sanity/image-url";
import { getSanityClient } from "../../sanintyClient";
import { format } from "date-fns";

const client = getSanityClient();
const { projectId, dataset } = client.config();
const postImage = (source) =>
  projectId && dataset
    ? imageUrlBuilder({ projectId, dataset }).image(source)
    : null;

function BlogContent() {
  const [categories, setCategories] = useState(null);
  const [allPosts, setAllPosts] = useState(null);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "category"]{
            _id, 
            title, 
          }`
      )
      .then((data) => setCategories(data))
      .catch((err) => console.error(err));

    client
      .fetch(
        `*[_type == "blogPost"]{ _id, title, content, slug, author, publishedAt, mainImage, excerpt, categories[]-> {
            _id, 
            title
          }}`
      )
      .then((data) => setAllPosts(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="standard-blog-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            {Array.isArray(allPosts) && allPosts.length > 0
              ? allPosts.map((item) => (
                  <div className="standard-blog-item" key={item._id}>
                    <div className="standard-blog-thumb">
                      <Link to={`/blog/${item._id}`}>
                        <img
                          src={postImage(item.mainImage.asset._ref)}
                          alt={item.title}
                        />
                      </Link>
                    </div>
                    <div className="standard-blog-content">
                      <div className="blog-post-meta">
                        <ul>
                          <li className="tags">
                            <i className="flaticon-bookmark-1" />
                            {Array.isArray(item.categories) &&
                            item.categories.length > 0
                              ? item.categories.map((category, index) => (
                                  <a key={category._id} href="/#">
                                    {category.title}
                                    {index < item.categories.length - 1 &&
                                      ", "}{" "}
                                  </a>
                                ))
                              : null}
                          </li>
                          <li>
                            <i className="far fa-user" />
                            <a href="/#">{item.author || "Admin"}</a>
                          </li>
                          <li>
                            <i className="far fa-bell" />{" "}
                            {format(
                              new Date(item.publishedAt),
                              "MMMM dd, yyyy"
                            )}
                          </li>
                        </ul>
                      </div>
                      <h2 className="title">
                        <Link to={`/blog/${item._id}`}>
                          {item.title || "Working For Dog Adoption"}
                        </Link>
                      </h2>
                      <p>{item.excerpt}</p>
                      <Link to={`/blog/${item._id}`} className="read-more">
                        Leer más <img src="img/icon/pawprint.png" alt="" />
                      </Link>
                    </div>
                  </div>
                ))
              : null}
          </div>
          <div className="col-lg-4 col-md-8">
            <aside className="blog-sidebar">
              <Catagories categories={categories} />
              <div className="widget">
                <h4 className="sidebar-title">Posteos Recientes</h4>
                <SideBarTitle posts={allPosts} postImage={postImage} />
              </div>
              <BlogNewsletter />
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogContent;
